export default "__VITE_ASSET__C8z9fAwW__"